import SectionHeader from "../../components/SectionHeader";
import { GridInputs } from "../../../../../../components/Functional";
import useUser from "../../../../../../hooks/useUser";

const BankDetails = props => {
  const { formik } = props;
  const { hasPermission } = useUser();

  const inputs = {
    className: "mt-5 grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-8",
    inputs: [
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            disabled: true,
            label: "Bank",
            name: "bank.details",
            rows: 20,
            type: "textarea",
            submitOnBlur: true,
          },
        ],
      },
      {
        className: "grid-cols-1 gap-4 lg:col-span-2",
        inputs: [
          {
            label: "Terms",
            name: "terms",
            rows: 20,
            type: "textarea",
            submitOnBlur: true,
            disabled: !hasPermission("UPDATE_INVOICE"),
          },
        ],
      },
    ],
  };

  const detailInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="w-full">
      <SectionHeader title="Bank Details" />
      <div className="px-4 sm:px-6 lg:px-8 pb-8">
        <GridInputs {...detailInputProps} />
      </div>
    </div>
  );
};

export default BankDetails;
